export default __webpack_public_path__ + "static/media/backspace.3f58eaa9.wav";